import z from "zod";

export const NewsletterOptions = z.enum([
  "golden-updates",
  "just-paint",
  "sagg-events",
  "domestic-sales",
  "international-sales",
  "paintworks",
  "canadian",
]);

export type NewsletterOptionsType = z.infer<typeof NewsletterOptions>;

export const BrandNewsletters = z.enum([
  "golden-acrylics",
  "williamsburg-oils",
  "qor-watercolors",
  "panpastel",
]);

export type BrandNewslettersType = z.infer<typeof BrandNewsletters>;

export const NewsletterSubscriptionDetail = z.object({
  newsletterSubscriptions: NewsletterOptions.array(),
  brandNewsletters: BrandNewsletters.array().optional(),
  firstName: z.string().optional(),
  lastName: z.string().optional(),
});

export type NewsletterSubscriptionDetailType = z.infer<typeof NewsletterSubscriptionDetail>;
